<template>
    <div class="rd-home">
        <loading
            :active.sync="open_loader"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#6366f1'"
        ></loading>

        <header class="rd-home__head">
            <h1 class="rd-home__title">Dobrodošli</h1>
            <p class="rd-home__sub">Odaberite gdje želite nastaviti.</p>
        </header>

        <div class="rd-grid">
            <button class="rd-tile" @click.prevent="goto('/prijave')">
                <span class="rd-tile__icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 12h6M9 16h6M9 8h2"/>
                        <path d="M9 4h6a2 2 0 0 1 2 2v0a2 2 0 0 0 2 2h0a2 2 0 0 1 0 0v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h0"/>
                        <rect x="9" y="3" width="6" height="3" rx="1"/>
                    </svg>
                </span>
                <span class="rd-tile__label">Otvorene prijave</span>
            </button>

            <button class="rd-tile" @click.prevent="goto('/webinari')">
                <span class="rd-tile__icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="2.5" y="6" width="13" height="12" rx="2.5"/>
                        <path d="M15.5 10.5l4.6-3.2a.8.8 0 0 1 1.4.7v8a.8.8 0 0 1-1.4.7l-4.6-3.2"/>
                    </svg>
                </span>
                <span class="rd-tile__label">{{ app_owner === 'HKOIG' ? 'Skupovi' : 'Webinari' }}</span>
            </button>

            <button class="rd-tile" @click.prevent="goto('/arhiva')">
                <span class="rd-tile__icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="4" width="18" height="4" rx="1"/>
                        <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8"/>
                        <path d="M10 12h4"/>
                    </svg>
                </span>
                <span class="rd-tile__label">{{ app_owner === 'HKOIG' ? 'Arhiva skupova' : 'Arhiva webinara' }}</span>
            </button>

            <button v-if="app_owner !== 'HKOIG' && !$embedded" class="rd-tile" @click.prevent="goto('/bodovi')">
                <span class="rd-tile__icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 4 2.5 9 12 14l9.5-5L12 4Z"/>
                        <path d="M6.5 11.5V16c0 1.4 2.5 2.5 5.5 2.5s5.5-1.1 5.5-2.5v-4.5"/>
                        <path d="M21.5 9v5"/>
                    </svg>
                </span>
                <span class="rd-tile__label">SSU bodovi</span>
            </button>
        </div>
    </div>
</template>

<script>

import Loading from "vue-loading-overlay";

export default {
    name: "Pocetna",
    components: {Loading},
    data(){
        return{
            open_loader: false,

            osoba: {},
            stavke: [],
            dodatne_aktivnosti: [],
            app_owner: process.env.VUE_APP_APP_OWNER,
        }
    },

    methods: {
        goto(name) {
            this.$router.push(name)
        }
    },
}
</script>

<style scoped>
.rd-home__head { margin-bottom: 2rem; }
.rd-home__title { font-size: 1.9rem; font-weight: 800; margin: 0; }
.rd-home__sub { color: var(--rd-muted, #6b7280); margin: .35rem 0 0; font-size: 1.02rem; }

.rd-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 1.5rem;
}

.rd-tile {
    background: #fff;
    border: 1px solid var(--rd-border, #e6e8f0);
    border-radius: var(--rd-radius, 18px);
    box-shadow: var(--rd-shadow, 0 12px 28px -8px rgba(16,24,40,.14));
    padding: 2.5rem 1.5rem;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    text-align: center;
    transition: transform .18s ease, box-shadow .25s ease, border-color .2s ease;
}
.rd-tile:hover {
    transform: translateY(-6px);
    box-shadow: var(--rd-shadow-lg, 0 24px 48px -12px rgba(31,28,86,.28));
    border-color: rgba(99,102,241,.45);
}

.rd-tile__icon {
    width: 96px;
    height: 96px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);
    transition: transform .25s ease;
}
.rd-tile:hover .rd-tile__icon { transform: scale(1.05); }
.rd-tile__icon svg { width: 46px; height: 46px; color: var(--rd-primary-600, #4f46e5); }
.rd-tile:hover .rd-tile__icon svg { color: var(--rd-primary-700, #4338ca); }

.rd-tile__label {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--rd-text, #1e2330);
    letter-spacing: .2px;
}
</style>
